import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Package, Users, MapPin, FileText, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/components/Navbar";

const NAV = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/artists", label: "Artists", icon: Users },
  { to: "/admin/dealers", label: "Dealers", icon: MapPin },
  { to: "/admin/content", label: "Content", icon: FileText },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="flex">
        {/* sidebar */}
        <aside className="fixed left-0 top-0 z-40 hidden h-screen w-64 flex-col border-r border-black/10 bg-white md:flex">
          <div className="border-b border-black/10 p-6">
            <Link to="/">
              <img src={LOGO_URL} alt="GAVRA" className="h-7 w-auto" />
            </Link>
            <p className="mt-3 font-mono-hw text-[10px] uppercase tracking-[0.25em] text-black/40">Control Panel</p>
          </div>
          <nav className="flex-1 p-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`admin-nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `mb-1 flex items-center gap-3 px-4 py-3 text-[13px] font-bold uppercase tracking-wide transition-colors ${
                    isActive ? "bg-gavra text-white" : "text-black hover:bg-secondary"
                  }`
                }
              >
                <n.icon className="h-4 w-4" /> {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="border-t border-black/10 p-4">
            <a href="/" target="_blank" rel="noreferrer" className="mb-2 flex items-center gap-3 px-4 py-3 text-[13px] font-bold uppercase tracking-wide text-black hover:bg-secondary">
              <ExternalLink className="h-4 w-4" /> View site
            </a>
            <button
              data-testid="admin-logout-btn"
              onClick={doLogout}
              className="flex w-full items-center gap-3 px-4 py-3 text-[13px] font-bold uppercase tracking-wide text-black hover:text-gavra"
            >
              <LogOut className="h-4 w-4" /> Logout
            </button>
          </div>
        </aside>

        {/* main */}
        <div className="flex-1 md:ml-64">
          {/* mobile top bar */}
          <div className="flex items-center justify-between border-b border-black/10 p-4 md:hidden">
            <img src={LOGO_URL} alt="GAVRA" className="h-6 w-auto" />
            <div className="flex items-center gap-2">
              {NAV.map((n) => (
                <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `p-2 ${isActive ? "text-gavra" : "text-black"}`}>
                  <n.icon className="h-5 w-5" />
                </NavLink>
              ))}
              <button onClick={doLogout} className="p-2 text-black"><LogOut className="h-5 w-5" /></button>
            </div>
          </div>
          <div className="p-5 md:p-10">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
